import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import asset_smart_home_hero_bg from "@/assets/smart-home-hero-bg.png.asset.json";
import asset_smart_home_beratung_statt_gadgets from "@/assets/smart-home-beratung-statt-gadgets.png";
import asset_smart_home_alles_vernetzt from "@/assets/smart-home-alles-vernetzt.png";
import asset_smart_home_energie_intelligent_steuern from "@/assets/smart-home-energie-intelligent-steuern.png";
import asset_smart_home_sauber_installiert_wechselrichter from "@/assets/smart-home-sauber-installiert-wechselrichter.png";
import asset_smart_home_referenz_wohnzimmer from "@/assets/smart-home-referenz-wohnzimmer.png";
import asset_smart_home_crosslink_g2_contracting from "@/assets/smart-home-crosslink-g2-contracting.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function SmartHome() {
  return (
    <>
      <Seo
        title="Smart Home & Gebäudeautomation | Zweering Elektrotechnik Emmerich am Rhein"
        description="Smart-Home-Lösungen vom Elektro-Meisterbetrieb: Beratung, Planung und saubere Installation aus einer Hand in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/smart-home"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/smart-home"}, {"name": "Smart Home", "url": "https://zweering.de/smart-home"}]}
        schema={serviceSchema("Smart-Home-Installation", "Planung und Installation von Smart-Home- und Gebäudeautomations-Lösungen für Wohnhäuser in Emmerich am Rhein und Umgebung.", "https://zweering.de/smart-home")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="SMART HOME"
      subline="Ihr Zuhause, intelligent vernetzt. Smart-Home-Lösungen vom Elektro-Meisterbetrieb — geplant und installiert aus einer Hand, in Emmerich am Rhein und Umgebung."
      heroImage={asset_smart_home_hero_bg.url}
      heroImageAlt="Helles, modernes Wohnzimmer mit Smart-Home-Wanddisplay, großem Sofa und Tageslicht"
      leadText={
        <>
          Licht, Heizung, Beschattung, Energie — ein Smart Home verbindet alles zu einem
          System, das mitdenkt. Richtig gemacht ist es kein Spielzeug, sondern{" "}
          <span style={{ color: "#4CAF50" }}>echter Komfort und gesparte Energie</span>.
        </>
      }
      panels={[
        {
          title: "BERATUNG STATT GADGETS",
          body: "Smart Home ist mehr als ein paar smarte Steckdosen. Wir planen ein durchdachtes System, das zu Ihrem Zuhause und Ihrem Alltag passt — herstellerunabhängig.",
          image: asset_smart_home_beratung_statt_gadgets,
          imageAlt: "Smarte Türsprechanlage mit Kamera und Codetastatur an einer moderner Hauseingangsfassade",
        },
        {
          title: (
            <>
              ALLES <span style={{ color: "#4CAF50" }}>VERNETZT</span>
            </>
          ),
          body: "Licht, Heizung, Rollläden, Sicherheit und Energie laufen in einem System zusammen — bedienbar per App, Sprache oder Schalter, ganz wie Sie wollen.",
          image: asset_smart_home_alles_vernetzt,
          imageAlt: "Elektriker installiert Kabel und Klemmen in einer offenen Wallbox", 
        },
        {
          title: "ENERGIE INTELLIGENT STEUERN",
          body: "Ihr Smart Home arbeitet mit PV-Anlage, Speicher und Wallbox zusammen — Verbraucher laufen dann, wenn Ihr eigener Strom verfügbar ist.",
          image: asset_smart_home_energie_intelligent_steuern,
          imageAlt: "Moderne Smart-Home-Wandschalter und Dimmer in Anthrazit",
        },
        {
          title: "SAUBER INSTALLIERT",
          body: "Als Elektro-Meisterbetrieb verbinden wir die Technik fachgerecht mit Ihrer Elektroinstallation — zukunftssicher und erweiterbar.",
          image: asset_smart_home_sauber_installiert_wechselrichter,
          imageAlt: "Fachgerecht an der Wand installierter Wechselrichter mit Verteiler und sauber verlegten Kabeln",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      manifest={"EIN ZUHAUSE.\nDAS MITDENKT.\nUND ENERGIE SPART."}
      caseStudy={{
        title: "SMART HOME MIT ENERGIE-ANBINDUNG",
        text: "Vernetzte Steuerung von Licht, Heizung und Energie, installiert aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "#referenzen",
        image: asset_smart_home_referenz_wohnzimmer,
        imageAlt: "Modernes Wohnzimmer abends mit stimmungsvoller Beleuchtung und Smart-Home-Steuerung",
      }}
      faq={[
        {
          frage: "Brauche ich für Smart Home einen Neubau?",
          antwort:
            "Nein. Viele Lösungen lassen sich auch im Bestand nachrüsten. Wir prüfen, was bei Ihnen sinnvoll und möglich ist.",
        },
        {
          frage: "Welches System nutzen Sie?",
          antwort:
            "Wir sind herstellerunabhängig und wählen das System, das zu Ihren Anforderungen passt — nicht umgekehrt.",
        },
        {
          frage: "Kann ich klein anfangen und später erweitern?",
          antwort:
            "Ja. Wir planen Ihr System so, dass Sie schrittweise erweitern können — ohne alles neu zu machen.",
        },
        {
          frage: "Arbeitet Smart Home mit meiner PV-Anlage zusammen?",
          antwort:
            "Ja. Wir binden Smart Home, PV, Speicher und Wallbox zu einem Energiesystem zusammen, das Ihren Eigenverbrauch optimiert.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜR EIN SMARTES ZUHAUSE?",
        subtext: "Kostenlose Beratung — wir planen Ihr Smart Home durchdacht.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "G2 CONTRACTING",
        text: "Die intelligente Ebene über Ihrem Energiesystem.",
        href: "/g2-contracting",
        image: asset_smart_home_crosslink_g2_contracting,
        imageAlt: "Landwirtschaftliches Gebäude mit großflächiger Photovoltaikanlage auf dem Dach",
      }}
    />
    </>
  );
}
